import axios from 'axios';
import { API_URL, config } from '../../../config/config';

const getMasterEntryById = async ({ id }) => {
	const response = await axios.post(
		`${API_URL}/master-entry/get-master-entry`,
		{
			pagination: false,
			MasterTypeId: id,
		},
		config
	);
	return response.data;
};

const createMasterEntry = async ({ masterValue, parentId }) => {
	const response = await axios.post(
		`${API_URL}/master-entry/create-master-entry`,
		{
			MasterTypeId: '2',
			MasterValue: masterValue,
			ParentId: parentId,
		},
		config
	);

	return response.data;
};

const getAllMasterTypes = async () => {
	const response = await axios.post(`${API_URL}/master-entry/get-master-type`, {}, config);
	return response.data;
};

const getAllSupplier = async () => {
	const response = await axios.post(`${API_URL}/account-details/get-all-suppliers`, {}, config);
	return response.data;
};

const getGstStateCodes = async () => {
	const response = await axios.post(`${API_URL}/gst/get-gst-state-code`, {}, config);
	return response.data;
};

const getGstPercentage = async () => {
	const response = await axios.post(`${API_URL}/gst/get-gst-percentage`, {}, config);
	return response.data;
};

const getAllProductsLot = async (id) => {
	const res = await axios.post(
		`${API_URL}/product-master/get-all-products-lot`,
		{ AccountId: id },
		config
	);
	return res.data;
};

const getBrands = async (id) => {
	const res = await axios.post(`${API_URL}/product-master/get-brands`, { ProductId: id }, config);
	return res.data;
};

const getDesignNumber = async (data) => {
	const res = await axios.post(`${API_URL}/product-master/get-design-number`, data, config);
	return res.data;
};

const getAllSizes = async (data) => {
	const res = await axios.post(`${API_URL}/product-master/get-all-sizes`, data, config);
	return res?.data;
};
const getAllSizeGroups = async (data) => {
	const res = await axios.post(`${API_URL}/product-master/get-all-size-groups`, data, config);
	return res?.data;
};

const getColorSlots = async (data) => {
	const res = await axios.post(`${API_URL}/product-master/get-color-size-slot`, data, config);
	return res?.data;
};

const getSizeSlots = async (data) => {
	const res = await axios.post(`${API_URL}/product-master/get-size-slot-designId`, data, config);
	return res?.data;
};

const getAllModulesDropdowns = async () => {
	const res = await axios.post(`${API_URL}/module-access/get-all-modules`, {}, config);
	return res?.data;
};

///

const getArticleCodes = async (data) => {
	const res = await axios.post(`${API_URL}/product-master/get-article-code`, data, config);
	return res?.data;
};

const dropdownService = {
	getGstStateCodes,
	createMasterEntry,
	getAllMasterTypes,
	getAllSupplier,
	getMasterEntryById,
	getGstPercentage,
	getAllProductsLot,
	getBrands,
	getDesignNumber,
	getAllSizes,
	getColorSlots,
	getSizeSlots,
	getAllModulesDropdowns,
	getArticleCodes,
	getAllSizeGroups,
};

export default dropdownService;
